import { format } from 'date-fns';

export default function timestampDisplay(timestamp: string | number): string {
  return format(new Date(timestamp), 'EEEE, MMMM d, y \'at\' h:mm a');
}
